import { render, staticRenderFns } from "./OrderQuizButton.vue?vue&type=template&id=0cef6079"
import script from "./OrderQuizButton.vue?vue&type=script&lang=js"
export * from "./OrderQuizButton.vue?vue&type=script&lang=js"
import style0 from "./OrderQuizButton.vue?vue&type=style&index=0&id=0cef6079&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports